import { memo } from 'react';
import { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const styles = {
  boxStyle: {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: {
      xs: '90%',
      md: '1000px'
    },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    width: '100%',
    maxHeight: 800,
    overflow: 'auto',
    padding: '0px 32px',
    overflowX: 'hidden'
  },
  titleContainer: {
    zIndex: '99',
    position: 'sticky' as const,
    backgroundColor: 'white',
    top: '0px',
    height: '60px'
  },
  titleContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  closeIcon: {
    position: 'absolute' as const,
    top: '4px',
    color: '#a1a1a1'
  }
};

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title?: string | React.ReactNode;
  style?: SxProps<Theme>;
  rightIcon?: string;
};

function GenericModalV2({
  isOpen,
  onClose,
  title,
  children,
  style,
  rightIcon = '-28px'
}: Props) {
  return (
    <Modal
      aria-describedby={`${title}-modal-description`}
      aria-labelledby={`${title}-modal-title`}
      onClose={onClose}
      open={isOpen}
    >
      <Box sx={{ ...styles.boxStyle, ...style }}>
        <div style={styles.titleContainer}>
          <IconButton
            aria-label="close"
            data-testid="generic-modal-close-button"
            onClick={onClose}
            sx={{ ...styles.closeIcon, right: rightIcon }}
          >
            <CloseIcon />
          </IconButton>

          <div style={styles.titleContent}>
            <Typography
              color="#063468"
              data-testid="generic-modal-title"
              fontSize="14px"
              fontWeight="500"
              marginTop="1em"
              textAlign="center"
              whiteSpace="pre-wrap"
            >
              {title}
            </Typography>
          </div>
        </div>

        {children}
      </Box>
    </Modal>
  );
}

export default memo(GenericModalV2);
